import { Notification } from '@sit/client-shared';

/**
 * Mutates in place! Returns just for convenience.
 */
export function sortNotificationsDesc(notifications: Notification[]): Notification[] {
  return notifications.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
}
